const locationColors = {
    1: '#14b8a6',
    6: '#4B75BA',
    9: '#8b5cf6',
}

export function dashboardLocationColor(locationId) {
    return locationColors[locationId] || '#64748b'
}

export const dashboardSalesColor = '#4c5875'
